import { SOCIALS } from "@/config/kingbullish";
import { SOCIAL_ICONS, SOCIAL_BRAND_COLORS } from "@/components/brand/SocialIcons";

export const SocialLinks = ({ placement, labelled = false, compact = false, className = "" }) => (
  <nav
    aria-label={`KINGBULLISH social channels — ${placement}`}
    className={`social-links ${compact ? "social-links--compact" : ""} ${className}`}
    data-testid={`${placement}-socials`}
  >
    {SOCIALS.map(({ id, label, href }) => {
      const Icon = SOCIAL_ICONS[id];
      return (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label} (opens in a new tab)`}
          title={`${label} — KINGBULLISH`}
          className={`social-btn ${labelled ? "social-btn--labelled" : ""}`}
          style={{ "--brand": SOCIAL_BRAND_COLORS[id] }}
          data-testid={`${placement}-social-${id}`}
        >
          <Icon />
          {labelled && <span>{label}</span>}
        </a>
      );
    })}
  </nav>
);